module.exports = __webpack_public_path__ + "static/media/healthy.1716c8f2.png";